import PropTypes from "prop-types";

function Card({ width, height, custom, borderRadius, innerContent }) {
  const cardStyle = {
    rearLayerBg: "card-background bg-[#1b2730]",
    frontLayerBg: "card-transparent bg-[#2f3e50b9]",
    borderWidth: "card-border border-4",
    borderColor: "border-[#7f93aa22]",
  };

  return (
    <div
      className={
        "card-3d " +
        cardStyle.rearLayerBg +
        " " +
        width +
        " " +
        height +
        " " +
        custom +
        " " +
        borderRadius +
        " " +
        " translate-z-40"
      }
    >
      <div
        className={
          "card-3d " +
          borderRadius +
          " " +
          cardStyle.frontLayerBg +
          " " +
          " w-full h-full translate-z-40"
        }
      >
        <div
          className={
            "card-3d " +
            borderRadius +
            " " +
            cardStyle.borderWidth +
            " " +
            cardStyle.borderColor +
            " w-full h-full translate-z-40"
          }
        >
          {innerContent}
        </div>
      </div>
    </div>
  );
}

Card.defaultProps = {
  width: "w-full",
  height: "h-full",
  custom: "",
  borderRadius: "",
};

Card.propTypes = {
  height: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
  custom: PropTypes.string.isRequired,
  borderRadius: PropTypes.string.isRequired,
};

export default Card;
